import { isValidUUID } from './urlUtils';

/**
 * Normalise the join field on blur only (never per-keystroke, or a pasted
 * URL gets mangled while the user is still typing it). Resume codes are
 * upper-cased for consistency with how they're issued; anything that looks
 * like a link or domain (contains "://" or a dot) is left exactly as pasted,
 * since condensed uppercase makes a URL look broken.
 */
export const normalizeJoinInput = (value: string): string => {
  const trimmed = value.trim();
  if (trimmed.includes('://') || trimmed.includes('.')) {
    return trimmed;
  }
  return trimmed.toUpperCase();
};

/**
 * Pull a session UUID out of a pasted share link. Accepts a full URL or a
 * bare host+query (people paste "scan-drink-race.com/?session=..." without
 * the scheme). Returns null for anything that isn't a link carrying a valid
 * session id — callers fall back to treating the input as a resume code.
 */
export const extractSessionId = (value: string): string | null => {
  const trimmed = value.trim();
  const withScheme = /^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  try {
    const url = new URL(withScheme);
    const sessionParam = url.searchParams.get('session');
    if (sessionParam && isValidUUID(sessionParam)) {
      return sessionParam;
    }
  } catch {
    // Not a URL — fall through
  }
  return null;
};
